import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BolkService {


  constructor(private http : HttpClient) { }

  createBolkRequest = (copyright: Object) : Observable<Object> => this.http.post<Object>('../rl/request/bolk', copyright);

  extendBolkRightsClearance = (citation: Object) : Observable<Object> => this.http.post<Object>('../rl/request/bolk/orderRightClearance', citation);

  acceptBolkRightsClearance = (citation: Object) : Observable<Object> => this.http.post<Object>('../rl/request/bolk/acceptRightClearance', citation);

  rejectBolkRightsClearance = (citation: Object) : Observable<Object> => this.http.post<Object>('../rl/request/bolk/rejectRightClearance', citation);

  lockBolkRequests = (course: Object) : Observable<Object> => this.http.post<Object>('../rl/request/bolk/lockBolkRequests', course);

  getBolkUrlFile = (citationId: number) : Observable<Object> => this.http.get<Object>(`../rl/request/bolk/citation/${citationId}/file`);
 
  hasISBNApprovedRequests = (citationId: number) : Observable<boolean> => this.http.get<boolean>(`../rl/request/bolk/citation/${citationId}/hasIsbnApprovedRequests`);

}
